import { Injectable } from '@angular/core';
import { RootScopeService } from './root-scope.service';
import { NewAgentApiService } from './new-agent-api.service';
import { Global } from '../global/globalApi';
import { FormControl, FormGroup } from '@angular/forms';
import * as Constants from './../models/Constants';
import { AaaSModel, sAuthModel } from '../models/customer.model';
import { LogService } from './log.service';
import { HttpStatusCode } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class AaaSService {
  public AaaSFieldListData: any = {};
  public AaaSForm: FormGroup = new FormGroup({});
  public asssAuthMethodData: any;
  public fileName = 'AaaSService';
  constructor(public rootScope: RootScopeService, public httpService: NewAgentApiService, public logger: LogService) {

  }

  /**
  * @author Amarjeet kumar
  * getAaaSFtuFieldData()- calling API to get the AaaS FTU fields  
  * Based on CCR3-10272
  */
  getAaaSFtuFieldData() {
    let payload = { clientId: this.rootScope.activeCustTab.clientId };
    
    this.httpService.getApi(Global.authenticationApis.getAaaSFtuFields, payload, 'false', false).subscribe({
      next: (res) => {

        if (res && res?.data) {
          this.getAaasUserAuthMethod(true);
          this.AaaSFieldListData[this.rootScope.activeCustTab.clientId] = res.data;
          this.createAaaSForm();
          this.logger.debugLogs("getAaaSFtuFieldData API: " + JSON.stringify(res.data), this.fileName);

        }
      },
      error: (error) => {
      this.getAaasUserAuthMethod(true);
      this.AaaSFieldListData[this.rootScope.activeCustTab.clientId] = null;
      this.logger.errorLogs("Error in getAaaSFtuFieldData API: " + JSON.stringify(error), this.fileName);
      }
    })
  }

  /**
* @author Amarjeet kumar
* createAaaSForm()- creating AaaS form dynamically based on the API response.  
* Based on CCR3-10272
*/
  createAaaSForm() {
    const controls = {};
    let aaasFormField = this.AaaSFieldListData[this.rootScope.activeCustTab.clientId]?.ftuIdentityProvidersList
      ;
    if (aaasFormField) {
      aaasFormField.forEach((res) => {
        const validationsArray = [];
        // res.validations.forEach((val) => {
        //   if (val.name === 'required') {
        //     validationsArray.push(Validators.required);
        //   }
        //   if (val.name === 'pattern') {
        //     validationsArray.push(Validators.pattern(val.validator));
        //   }
        // });
        controls[res.fieldName] = new FormControl('', validationsArray);
      });
    }
    this.AaaSForm = new FormGroup(controls);
  }

  /**
   * @author Amarjeet kumar
   * resetAaaSForm()- resetting AaaS form to its initial state.   
   */
  resetAaaSForm() {
    this.AaaSForm.reset();
  }

  /**
 * @author Amarjeet kumar
 * onSubmit()- submitting AaaS form data.
 */
  onSubmit() {
    console.log(this.AaaSForm.value);
  }

  //CCR3-CCR3-8676
  /**
   * Retrieves the authentication methods for an AAAS (Authentication as a Service) user.
   * 
   * @param config - Optional configuration parameter. If provided, it determines whether to update 
   *                 the authentication contents or not.
   * 
   * This method constructs a payload using the active customer's tab data and sends a POST request 
   * to the AAAS authentication API. Upon receiving a successful response, it updates the 
   * authentication contents for the active customer tab and logs the operation. If the API call 
   * fails, it sets the authentication configuration as missing and logs the error.
   * 
   * The method performs the following:
   * - Sends a POST request to fetch authentication methods.
   * - Updates the `authenticationContents` of the active customer tab if applicable.
   * - Logs success or failure messages.
   * - Handles errors by marking the configuration as missing and initializing a new `sAuthModel`.
   * 
   * @remarks
   * - The `config` parameter determines whether the method updates the authentication contents 
   *   or simply updates the authentication methods.
   * - The method relies on `this.rootScope` and `this.httpService` for accessing the active 
   *   customer tab and making HTTP requests, respectively.
   * 
   * @example
   * // Example usage:
   * this.getAaasUserAuthMethod();
   * this.getAaasUserAuthMethod({ someConfig: true });
   */
  getAaasUserAuthMethod(config?) {
    //this.rootScope.activeCustTab.tabData.tabData.
    let payload = {
      clientId: this.rootScope.activeCustTab.clientId,
      gpID: "5b7b14924fd8b7244cdef93f",
      customerType: this.rootScope.activeCustTab.customerType
    };

    let url = Global.authenticationApis.getAaasAuthMethods;
    this.httpService.postApi(url, payload, 'false', Constants.apiVersions, false).subscribe({
      next: (res) => {
        if (res && res?.data) {
          if (config || (this.rootScope.activeCustTab.authenticationContents?.length === 0)) {
            const resData = {
              clientId: this.rootScope.activeCustTab.clientId,
              customerType: this.rootScope.activeCustTab.customerType,
              authenticationContents: res?.data?.authenticationContentConfiguration

            };
            if (this.rootScope.activeCustTab.authenticationContents) {
              if (!this.rootScope.activeCustTab.authenticationContents.find(x => x.clientId === resData.clientId && x.customerType === resData.customerType)) {
                this.rootScope.activeCustTab.authenticationContents.push(resData);
              } else {
                let index = this.rootScope.activeCustTab.authenticationContents.findIndex(x => x.clientId === resData.clientId && x.customerType === resData.customerType);
                this.rootScope.activeCustTab.authenticationContents[index] = resData;
              }
              this.rootScope.activeCustTab.authenticationContents["selectedAuthenticationContent"] = res?.data?.authenticationContentConfiguration;

              this.logger.debugLogs('getAuthenticationContentList successfully called for clientId:' + resData.clientId + ' and customerType: ' + resData.customerType +" aaasIdentifyUser:"+JSON.stringify(res.data), this.fileName);

            }
          }
          this.updateClientConfig(res);
          this.updateAuthenticationMethods(res?.data);
          if(!res.data?.gpID){
            this.rootScope.accountAaaSConfig.AAASUserAPIFail = true;
          }
        }
      },
      error: (error) => {
        this.rootScope.accountAaaSConfig = new AaaSModel();
        if (error?.status == HttpStatusCode.InternalServerError) {
          this.rootScope.accountAaaSConfig.InternalServerError = true;
        }
        else {
          this.rootScope.accountAaaSConfig.AAASUserAPIFail = true;

        }
        this.rootScope.AaaSConfigUserDataMap[this.rootScope.activeCustTab.customerSessionId] = this.rootScope.accountAaaSConfig
        this.rootScope.logMessage(Constants.ERROR, 'getAuthenticationContentList API failure Error for CustomerSessionId: ' + this.rootScope.activeCustTab.customerSessionId + " " + JSON.stringify(error));
      }
    })
  }

  
  //CCR3-CCR3-8676
  /**
   * Updates the authentication methods for the current user based on the provided response data.
   *
   * @param response - The response object containing authentication-related information.
   * 
   * The method performs the following updates:
   * - Sets the `FTU` (First Time User) flag to `true` if the user is not onboarded.
   * - Sets the `PIN` and `PINCNG` flags to `true` if the user's service center PIN status is active and they are onboarded.
   * - Sets the `OTC` (One-Time Code) flag to `true` if the user has any MFA (Multi-Factor Authentication) methods configured.
   * - Sets the `PINRESET` flag to `true` if the user is locked out.
   * - Updates the `pswdResetDate` with the user's last password update timestamp.
   * 
   * The updated authentication model is stored in:
   * - `this.rootScope.AaaSConfigUserDataMap` using the active customer's session ID as the key.
   * - `this.rootScope.accountAaaSConfig` for global access.
   */
  updateAuthenticationMethods(response): void {
    const AaasModel = new AaaSModel();

    if (!response?.onboarded) {
      AaasModel.FTU = true;
    }
    else if (response?.serviceCenterPinStatus === 'active' && response.onboarded) {
      AaasModel.PIN = true; AaasModel.PINCNG = true; AaasModel.PINRESET = true;
    }

    if (response?.mfaMethods?.length > 0 && Constants.OTCmethods.find(x => response?.mfaMethods?.includes(x))) {
      AaasModel.OTC = true;
    }
    if (response?.lockedOut) {
      AaasModel.PINRESET = true;
    }

    AaasModel.pswdResetDate = response?.passwordLastUpdatedAt;
    this.rootScope.AaaSConfigUserDataMap[this.rootScope.activeCustTab.customerSessionId] = AaasModel;
    this.rootScope.accountAaaSConfig = AaasModel;


  }



  /**
   * Updates the client configuration based on the provided response data.
   * 
   * This method processes the `authenticationContentConfiguration` from the response object
   * and updates the `authMethodConfig` in the application's root scope. It ensures that the 
   * `platformSupport` property is parsed as JSON and handles any parsing errors gracefully.
   * 
   * @param res - The response object containing the client configuration data.
   * 
   * @throws Will log an error if there is an issue parsing the `platformSupport` property or 
   *         any other unexpected error occurs during the update process.
   */
  public updateClientConfig(res) {

    try {
      if (res&&!this.rootScope.authMethodConfig.get(this.rootScope.activeCustTab.clientId)?.find(x =>
        x?.customerType === this.rootScope.activeCustTab.customerType&&x.securityMethodCode!== Constants.AuthMenu.IND_DATA)) {
        res?.data?.authenticationContentConfiguration?.forEach((element, index) => {
          if (element?.platformSupport) {
            try {
              res.data.authenticationContentConfiguration[index].platformSupport = JSON.parse(element?.platformSupport);

            } catch (error) {
              res.data.authenticationContentConfiguration[index].platformSupport = {};
              this.logger.errorLogs("Error in parsing platformSupport: " + JSON.stringify(error), this.fileName);
            }

          }
        });

        setTimeout(() => {
          let authMethodConfig = this.rootScope.authMethodConfig.get(this.rootScope.activeCustTab.clientId) || [];
          if (authMethodConfig.length === 0) {
            this.rootScope.authMethodConfig.set(this.rootScope.activeCustTab.clientId, res.data?.authenticationContentConfiguration);
          } else {
            authMethodConfig = authMethodConfig.concat(res.data?.authenticationContentConfiguration);
            this.rootScope.authMethodConfig.set(this.rootScope.activeCustTab.clientId, authMethodConfig);
          }
        }, 10);
      }
    } catch (error) {
      this.logger.errorLogs("Error in parsing platformSupport: " + JSON.stringify(error), this.fileName);
    }
  }

  /**
   * Handles the FTU (First Time User) information message logic.
   * CCR3-10808
   * @param self - The context or instance to be used within the method.
   */
  aaasFTUInfoMsg(self) {
    switch (true) {
      case this.rootScope.accountAaaSConfig.FTU:

        break;

      default:
        break;
    }
  }
  /**
   * Handles the OTC (One-Time Code) information message logic.
   * CCR3-10808
   * @param self - The context or instance to be used within the method.
   */
  aaasOTCInfoMsg(self) {
    let status = false;
    switch (true) {
      case this.rootScope.accountAaaSConfig.FTU:
        self.infoMessage=Constants.AUTH_FTU;
        status = true;
        break;
      case this.rootScope.accountAaaSConfig.OTC:
        self.infoMessage = '';
        break;

      default:
        self.infoMessage = Constants.AuthMethods[Constants.AuthMenu.OTC] + " " + Constants.NOT_CONFIGURED_CUSTTYPE;
        status = true;
        break;
    }
    return status;
   }
  /**
   * Handles the PIN entry information message logic.
   * CCR3-10808
   * @param self - The context or instance to be used within the method.
   */
  aaasPinEntryInfoMsg(self) {
    switch (true) {
      case this.rootScope.accountAaaSConfig.FTU:
        self.peaDisabled = true;
        self.peaToolTipMsg =Constants.AUTH_FTU;
        break;
      case this.rootScope.accountAaaSConfig.PIN:
        self.peaDisabled = false;
        self.peaToolTipMsg = '';
        break;

      default:
        self.peaDisabled = true;
        self.peaToolTipMsg = Constants.PEA_MESSAGES.NO_PIN_ON_FILE;
        break;
    }
    return self.peaToolTipMsg;
  }
  /**
   * Handles the PIN change information message logic.
   * CCR3-10808
   * @param self - The context or instance to be used within the method.
   */

  aaasPinCngInfoMsg(self) {
    switch (true) {
      case (this.rootScope?.accountAaaSConfig?.FTU):
        self.pinChangeEnabled = false;
        self.pinChangeErrMsg = Constants.AUTH_FTU;
        break;
      case (this.rootScope?.activeCustTab?.CS_SECURITY_LEVEL != Constants.securityLevels.SL4):
        self.pinChangeEnabled = false;
        self.pinChangeErrMsg = Constants.PEA_MESSAGES.NOT_AVAILABLE_UNSECURED_CALL;
        break;
      case (!this.rootScope?.accountAaaSConfig.PINCNG):
        self.pinChangeEnabled = false;
        self.pinChangeErrMsg = Constants.PEA_MESSAGES.NO_PIN_ON_FILE;
        break;

      default:
        self.pinChangeEnabled = true;
        self.pinChangeErrMsg = '';
        break;

    }

  }

  /**
   * Handles the PIN reset information message logic.
   * CCR3-10808
   * @param self - The context or instance to be used within the method.
   * 
   * @returns A boolean indicating whether the PIN reset information message is displayed.
   */
  aaasPinResetInfoMsg(self) {
    let status = false;
    switch (true) {
      case (!this.rootScope.accountAaaSConfig.PINRESET ):
        self.infoMessage = Constants.AuthMethods[Constants.AuthMenu.PINRESET] + " " + Constants.NOT_CONFIGURED_CUSTTYPE;
        status = true;
        break;

      default:
        self.infoMessage = '';
        status = false;
        break;

    }
    return status;
   }



}
